import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import client from "@/lib/api";

const MaintenanceContext = createContext({ enabled: false, message: "", refresh: () => {} });

export function MaintenanceProvider({ children }) {
  const [state, setState] = useState({ enabled: false, message: "" });

  const refresh = useCallback(() => {
    client
      .get("/maintenance-status")
      .then((r) => setState({ enabled: !!r?.data?.enabled, message: r?.data?.message || "" }))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
    const handle = setInterval(refresh, 5 * 60 * 1000); // 5 min poll
    return () => clearInterval(handle);
  }, [refresh]);

  return (
    <MaintenanceContext.Provider value={{ ...state, refresh }}>
      {children}
    </MaintenanceContext.Provider>
  );
}

export function useMaintenance() {
  return useContext(MaintenanceContext);
}
